export enum CameraMode {
    User = "user",
    Environment = "environment"
}

export enum HttpResource {
    Jobs = "jobs",
    UnitChecks = "unit-checks",
    UnitCheckTodoResults = "unit-check-todo-results"
}